import { render, staticRenderFns } from "./OrdersProductsCategoriesTable.vue?vue&type=template&id=64d0ae80&"
import script from "./OrdersProductsCategoriesTable.vue?vue&type=script&lang=js&"
export * from "./OrdersProductsCategoriesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports